import React from 'react';
import { monthDayTime, prettyDate } from '@/utils/dates';
import { useScout } from '@/hooks/useScout';

interface Props {
  url: string;
  timestamp: string;
  sequence?: string;
  onClick: () => void;
  isActive?: boolean;
}

const Thumbnail: React.FC<Props> = ({
  url,
  timestamp,
  sequence,
  onClick,
  isActive,
}) => {
  const { quarantined } = useScout();

  return (
    <div
      data-quarantined={sequence && quarantined.includes(sequence)}
      className="flex cursor-pointer flex-col gap-4 data-[quarantined=true]:opacity-50"
      onClick={onClick}>
      <div className="aspect-h-1 aspect-w-2 flex w-full">
        <img
          data-active={isActive}
          className={
            'rounded-md border-2 border-transparent data-[active=true]:border-neutral-0'
          }
          src={url}
          alt="Active sequence"
        />
      </div>
      <div>
        <div className="text-sm font-bold md:text-base">
          {monthDayTime(timestamp)}
        </div>
        <div className="text-xs">{prettyDate(timestamp, true)}</div>
      </div>
    </div>
  );
};

export default Thumbnail;
